export default __webpack_public_path__ + "images/kw-2dce482defe9d86d05967143aaeb7d3a.svg";